// Hash restoration utility
// This runs on authenticated pages to restore hash fragments after sign-in
(function() {
  var currentPath = window.location.pathname;
  var storedHash = sessionStorage.getItem('auth_redirect_hash');
  var storedPath = sessionStorage.getItem('auth_redirect_path');

  // Skip restoration on sign-in page
  if (currentPath.includes('/users/sign_in') || currentPath.includes('/goto')) {
    return;
  }

  // Restore hash if we're on the correct page
  if (storedHash && storedPath && currentPath === storedPath) {
    sessionStorage.removeItem('auth_redirect_hash');
    sessionStorage.removeItem('auth_redirect_path');

    if (window.location.hash !== storedHash) {
      window.location.hash = storedHash;
    }
  }
})();
